import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scholarship',
  templateUrl: './scholarship.component.html',
  styleUrls: ['./scholarship.component.scss'],
})
export class ScholarshipComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
